import { render } from "./ListeCategoriePage.vue?vue&type=template&id=429d5c5b&ts=true"
import script from "./ListeCategoriePage.vue?vue&type=script&lang=ts"
export * from "./ListeCategoriePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__